import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {GaTrackingEventName, GATrackingEventType} from '../../constants';

export class GATrackingBreadcrumbEvent implements GATrackingEvent {

  constructor(private categoryName: string) {

  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.BreadcrumbClick;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.Navigation,
      label: this.categoryName
    };
  }
}
